module.exports = __webpack_public_path__ + "static/img/improvement_3.2509a1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/improvement_3.png
// module id = sEal
// module chunks = 1